import { ref } from 'vue';
import { defineStore } from 'pinia';

/**
 * This store is responsible for managing the pagination state of the reviews section.
 * It keeps track of the current page number.
 */

/**
 * Pinia store for managing reviews that contain photos.
 * @returns {{
 *  page: import('vue').Ref<number>,
 *  handlePageChange: (pageNumber: string ) => void
 * }}
 */
const useReviewsPaginationStore = defineStore('reviewsPaginationStore', () => {
  // State
  /**
   * reviews paginated page number
   * @type {import('vue').Ref<number>}
   */
  const page = ref<number>(1);

  // Actions
  /**
   * Assigns page pagination value
   */
  function handlePageChange(pageNumber: string) {
    page.value = parseInt(pageNumber, 10);
  }

  return {
    // State
    page,
    // Actions
    handlePageChange,
  };
});

export default useReviewsPaginationStore;
